import React from 'react';
import './Home.css';

const experiences = [
    {
        year: 'Oct 2021 - Aug 2024',
        role: 'Software Development Engineer',
        company: 'Amazon Web Services, Inc',
        details: [
            'Developed and maintained a static website in TypeScript and NodeJs, including end-to-end test infrastructure using WDIO Test Framework.',
            'Developed CloudWatch dashboards, configured alarms, reviewed monitoring capabilities, and iteratively improved system observability.',
            'Led real-time troubleshooting and issue resolution during game days, enhancing team readiness for launches. Improved incident response by 40%.',
            'Automated compliance-ready QuickSight dashboard deployment with CDK, eliminating manual errors and enhancing productivity by 60%.',
            'Developed rigorous test plans and strategies, conducted data validation, simulated scenarios, and led troubleshooting driving quality. Enhanced test coverage and reliability by over 70%.',
            'Developed and implemented an Authorization Lambda using AWS SigV4 for request authentication, granting access to API endpoints.',
            'Implemented session timeout and subdomain strategies enhancing security improving user experience and boosting security, leading to a 25% reduction in unauthorized access attempts.',
            'Implemented a robust data service layer, orchestrating raw data ingestion, staging, and abstraction to generate optimized PostgreSQL queries for comprehensive user and company insights.'
        ]
    },
    {
        year: 'Mar 2021 - Sept 2021',
        role: 'Software Engineer',
        company: 'Tata Consultancy Services',
        details: [
            'Proficiently executed data migration with SQL Server Integration Services (SSIS), ensuring seamless data transfer across systems. Utilized ETL processes for data cleansing, transformation, and load, ensuring data integrity.',
            'Collaborated cross-functionally to design and implement efficient migration solutions, focusing on transitioning from on-premises to Azure Synapse Analytics.'
        ]
    },
    {
        year: 'Jun 2020 - Sept 2020',
        role: 'Software Engineer Intern',
        company: 'Quicken Loans, Charlotte, North Carolina',
        details: [
            'Developed clean, validation-ready code for projects using Angular 9 and Node.js, ensuring efficient project execution and maintenance with a 15% increase in code quality.',
            'Strategically tagged fields for data analytics using Adobe Analytics, enabling actionable insights and decision-making optimization, resulting in a 35% improvement in data-driven strategies.',
            'Enhanced user experience by introducing edit functionality, enabling users to modify choices and access related products easily, contributing to a 20% rise in user engagement.'
        ]
    },
    {
        year: 'Jan 2019 - May 2020',
        role: 'Graduate Assistant of Cloud Computing',
        company: 'UNC Charlotte, North Carolina',
        details: [
            'Conducted lectures as a Teaching Assistant and contributed to the Google-sponsored Explore Computer Science Research (ExploreCSR) program with UNCC.',
            'Organized seminars showcasing Master’s / PhD projects, facilitating partnerships with undergraduates to introduce underrepresented groups to Computer Science Research and build confidence.',
            'Achieved a 70% positive response from students, indicating increased interest in research and pursuing a Master’s degree at UNCC.'
        ]
    }
];

function Home() {
    return (
        <div className="home">
            <h1 data-aos="fade-down">Tanmay Mhaske</h1>
            <div className="profile-container">
                <img src='./profile.jpg' alt="Profile" className="profile-image" />
                <div className="profile-info">
                    <h2>Work Experience</h2>
                    <p data-aos="fade-up" data-aos-delay="200">Scroll down to explore more!</p>
                    <ul className="timeline">
                        {experiences.map((experience, index) => (
                            <li key={index}>
                                <span className="year">{experience.year}</span>
                                <span className="role">{experience.role} at {experience.company}</span>
                                <ul className="details">
                                    {experience.details.map((detail, i) => (
                                        <li key={i} className="detail">{detail}</li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Home;